

// avoid iPad bounce effect during DragDrop//
document.ontouchmove = function(e){e.preventDefault();};


